import { Header } from '../../components/Header/Header';
import {
  Container,
  ContainerGraph,
  Content,
  Infos,
  Resume,
  Subtitle,
} from './styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import CardInfos from '../../components/CardInfos/CardInfos';
import { HistoricPaymentChart } from '../../components/Charts/HistoricPaymentChart';
import Footer from '../../components/Footer/Footer';
import { IoMdHome } from 'react-icons/io';
import { useState } from 'react';
import { useUser } from '../../hooks/useUser';
import { Loader } from '../../components/Loader/Loader';
import iconCliente from '../../assets/icons/Clientes.svg';
import iconContratos from '../../assets/icons/contratos.svg';
import iconParcelas from '../../assets/icons/Parcelas.svg';
import iconValorBase from '../../assets/icons/valor_base.svg';
import { OverviewChart } from '../../components/Charts/OverviewChart';
import { ReviewChart } from '../../components/Charts/ReviewChart';
import CardResume, { CardProps } from '../../components/CardResume/CardResume';

export function Home() {
  const { user } = useUser();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const firstPartName = user.user.nome.split(' ')[0];
  const fictice_values = [
    {
      icon: iconCliente,
      value: '50.000',
      ref: 'Clientes',
    },
    {
      icon: iconContratos,
      value: '100.000',
      ref: 'Contratos',
    },
    {
      icon: iconParcelas,
      value: '200.000',
      ref: 'Parcelas',
    },
    {
      icon: iconValorBase,
      value: 'R$ 10.000.000,00',
      ref: 'Valor da Base',
    },
  ];
  const fictice_Resume: CardProps[] = [
    {
      title: 'Quant. Total de Acordos',
      value: 154,
      type: 'quantity',
    },
    {
      title: 'Valor Total Negociado',
      value: 136653.01,
      type: 'money',
    },
    {
      title: 'Pagamento dos Acordos',
      value: 58247.65,
      type: 'money',
    },
  ];
  const dataHistoric = [25000, 45000, 35000, 30000, 55000, 0, 0, 0, 0, 0, 0];
  const months = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ];
  const dataOverview = [
    {
      name: 'Essa semana',
      data: [1000, 1500, 900, 800, 1500, 500, 1500],
    },
    {
      name: 'Semana passada',
      data: [1500, 1700, 2000, 1500, 1000, 1300, 1500],
    },
  ];
  const weeks = [
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
    'Domingo',
  ];
  const dataValueChanel = [6250, 2550, 2300, 2400, 3000];
  const chanel = ['Portal', 'Whatsapp', 'Ativo', 'Receptivo', 'Callback'];
  const dataQuantityChanel = [60, 27, 18, 5, 10];

  return (
    <>
      {loading && <Loader />}
      <Sidebar />
      <Container>
        <Header
          title="Painel"
          icon={<IoMdHome color="#A6A6A6" size="32px" />}
        />
        <Subtitle>
          <p>Olá {firstPartName}! Seja bem vindo(a) ao Painel do Lojista.</p>
        </Subtitle>
        <Content>
          <Infos>
            {fictice_values.map((values) => (
              <CardInfos
                icon={values.icon}
                key={values.ref}
                reference={values.ref}
                value={values.value}
              />
            ))}
          </Infos>
          {window.innerWidth <= 1024 && (
            <div className="cards">
              {fictice_Resume.map((fic) => (
                <CardResume
                  key={fic.title}
                  title={fic.title}
                  value={fic.value}
                  type={fic.type}
                />
              ))}
            </div>
          )}
          <ContainerGraph>
            <Resume>
              {window.innerWidth > 1024 && (
                <div className="cards">
                  {fictice_Resume.map((fic) => (
                    <CardResume
                      key={fic.title}
                      title={fic.title}
                      value={fic.value}
                      type={fic.type}
                    />
                  ))}
                </div>
              )}
              <div className="graphs">
                <ReviewChart
                  type="quantidade"
                  data={dataQuantityChanel}
                  categories={chanel}
                  title="Quant. de acordos por canal - Mês atual"
                />
                <ReviewChart
                  type="valor"
                  data={dataValueChanel}
                  categories={chanel}
                  title="Valor negociado por canal - Mês atual"
                />
              </div>
            </Resume>
            <OverviewChart
              data={dataOverview}
              categories={weeks}
              title="Overview - Acordos por Canal"
            />
            <HistoricPaymentChart
              data={dataHistoric}
              categories={months}
              title="Histórico de Pagamentos dos Acordos"
            />
          </ContainerGraph>
          <Footer />
        </Content>
      </Container>
    </>
  );
}
